import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c608502"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-code"]
const _hoisted_2 = { class: "fi-label-main" }
const _hoisted_3 = { class: "fi-popup-header" }
const _hoisted_4 = { class: "fi-popup-title" }
const _hoisted_5 = {
  key: 0,
  class: "fi-multi-tag"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fi-desc-icon" }, "i", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 选项说明 ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "fi-factor-desc"
}
const _hoisted_10 = {
  key: 1,
  class: "fi-union-row"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 选并集（选股结果中的股票分别属于所选选项） ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 选交集（选股结果中的股票同时属于所选选项） ")
const _hoisted_13 = {
  key: 2,
  class: "fi-options-wrap"
}
const _hoisted_14 = { class: "fi-options" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "fi-lock"
}
const _hoisted_17 = {
  key: 0,
  class: "fi-loading"
}
const _hoisted_18 = {
  key: 3,
  class: "fi-dropdown-wrap"
}
const _hoisted_19 = {
  key: 0,
  class: "fi-tags-label"
}
const _hoisted_20 = {
  key: 1,
  class: "fi-tags"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "fi-search-row" }
const _hoisted_23 = { class: "fi-list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "fi-list-name" }
const _hoisted_26 = {
  key: 1,
  class: "fi-list-check"
}
const _hoisted_27 = {
  key: 0,
  class: "fi-loading"
}
const _hoisted_28 = {
  key: 4,
  class: "fi-range-wrap"
}
const _hoisted_29 = { class: "fi-range-inputs" }
const _hoisted_30 = { class: "fi-range-fields" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "—", -1))
const _hoisted_32 = {
  key: 0,
  class: "fi-range-error"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 约")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("支股票，占全部股票的")
const _hoisted_35 = { class: "fi-dist-chart" }
const _hoisted_36 = { class: "fi-slider-track" }
const _hoisted_37 = { class: "fi-dist-axis" }
const _hoisted_38 = { class: "fi-footer" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { style: { color: '#666' } }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiLabelSub = _resolveComponent("FiLabelSub")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["factor-item", { selected: _ctx.selected, highlight: _ctx.highlight, 'has-sub': _ctx.hasSubLabelArea }]),
      "data-code": _ctx.factor.attrCode,
      style: _normalizeStyle({
      background: _ctx.selected ? '#FFEDED' : (_ctx.isLight ? '#f0f0f0' : '#2a2a2a'),
      color: _ctx.selected ? '#1a1a1a' : _ctx.colors.textPrimary,
      borderColor: _ctx.selected ? 'transparent' : 'transparent'
    }),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.factor.attrName), 1),
      (_ctx.showSubLabel && _ctx.displaySubLabel)
        ? (_openBlock(), _createBlock(_component_FiLabelSub, {
            key: 0,
            text: _ctx.displaySubLabel
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "fi-remove",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onRemoveTag && _ctx.onRemoveTag(...args)), ["stop"]))
          }, "×"))
        : _createCommentVNode("", true)
    ], 14, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showPopup)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fi-mask",
            onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["self"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["fi-popup", {
          'fi-popup--dropdown': [5, 6].includes(_ctx.factor.attrType),
          'fi-popup--range': _ctx.factor.attrType === 7,
        }]),
              onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.factor.attrName) + " ", 1),
                  (_ctx.isMulti)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "可多选"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasOptionDescs)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "fi-desc-btn",
                      onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDescBtnEnter && _ctx.onDescBtnEnter(...args))),
                      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDescBtnLeave && _ctx.onDescBtnLeave(...args)))
                    }, _hoisted_8, 32))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.factor.attrDesc || _ctx.factor.factorDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.factor.attrDesc || _ctx.factor.factorDescription), 1))
                : _createCommentVNode("", true),
              (_ctx.hasUnionSwitch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", {
                      class: "fi-union-opt",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.unionMode = 'union'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fi-checkbox", { checked: _ctx.unionMode === 'union' }])
                      }, null, 2),
                      _hoisted_11
                    ]),
                    _createElementVNode("label", {
                      class: "fi-union-opt",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.unionMode = 'intersect'))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fi-checkbox", { checked: _ctx.unionMode === 'intersect' }])
                      }, null, 2),
                      _hoisted_12
                    ])
                  ]))
                : _createCommentVNode("", true),
              ([1,2,3,4].includes(_ctx.factor.attrType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (opt) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: opt.attrCode,
                          class: _normalizeClass(["fi-option", { active: _ctx.pendingCodes.has(opt.attrCode), locked: opt.locked }]),
                          style: _normalizeStyle(_ctx.optionStyle(opt)),
                          onClick: ($event: any) => (_ctx.toggleOption(opt))
                        }, [
                          _createTextVNode(_toDisplayString(opt.attrName) + " ", 1),
                          (opt.locked)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "🔒"))
                            : _createCommentVNode("", true)
                        ], 14, _hoisted_15))
                      }), 128)),
                      (_ctx.loadingOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, "加载中..."))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ([5,6].includes(_ctx.factor.attrType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.factor.attrType === 6 || _ctx.pendingOptions.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["fi-tags-area", { 'fi-tags-area--empty': _ctx.factor.attrType === 6 && !_ctx.pendingOptions.length }])
                        }, [
                          (_ctx.pendingOptions.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "已选（" + _toDisplayString(_ctx.pendingOptions.length) + "）", 1))
                            : _createCommentVNode("", true),
                          (_ctx.pendingOptions.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingOptions, (opt) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: opt.attrCode,
                                    class: "fi-tag"
                                  }, [
                                    _createTextVNode(_toDisplayString(opt.attrName) + " ", 1),
                                    _createElementVNode("span", {
                                      class: "fi-tag-remove",
                                      onClick: ($event: any) => (_ctx.removePending(opt))
                                    }, "×", 8, _hoisted_21)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchKw) = $event)),
                        class: "fi-search",
                        placeholder: "搜索..."
                      }, null, 512), [
                        [_vModelText, _ctx.searchKw]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (opt) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: opt.attrCode,
                          class: _normalizeClass(["fi-list-item", { active: _ctx.pendingCodes.has(opt.attrCode) }]),
                          onClick: ($event: any) => (_ctx.toggleOption(opt))
                        }, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(opt.attrName), 1),
                          (_ctx.factor.attrType !== 6)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "fi-list-pct",
                                style: _normalizeStyle({ color: _ctx.pctColor(opt.changeRate) })
                              }, _toDisplayString(_ctx.formatPct(opt.changeRate)), 5))
                            : _createCommentVNode("", true),
                          (_ctx.pendingCodes.has(opt.attrCode))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "✓"))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_24))
                      }), 128)),
                      (_ctx.loadingOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "加载中..."))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.factor.attrType === 7)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rangeLeft) = $event)),
                          class: "fi-range-input",
                          placeholder: "最小值",
                          onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onRangeInput && _ctx.onRangeInput(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.rangeLeft]
                        ]),
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rangeRight) = $event)),
                          class: "fi-range-input",
                          placeholder: "最大值",
                          onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onRangeInput && _ctx.onRangeInput(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.rangeRight]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.factor.attrUnit || _ctx.factor.unit || '万'), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "fi-restore-btn",
                        style: {"background":"#e8392a","color":"#fff","border":"none"},
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.restoreDefault && _ctx.restoreDefault(...args)))
                      }, "恢复默认")
                    ]),
                    (_ctx.rangeError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.rangeError), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "fi-range-count",
                      style: _normalizeStyle({ color: _ctx.colors.textMuted })
                    }, [
                      _hoisted_33,
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.colors.textSecondary })
                      }, _toDisplayString(_ctx.rangeStockCount), 5),
                      _hoisted_34,
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.colors.textSecondary })
                      }, _toDisplayString(_ctx.rangeStockPct) + "%", 5)
                    ], 4),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("canvas", {
                        ref: "chartCanvas",
                        class: "fi-canvas",
                        onMousedown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onChartDrag && _ctx.onChartDrag(...args)))
                      }, null, 544),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", {
                          class: "fi-slider-handle",
                          style: _normalizeStyle({ left: _ctx.leftHandlePos + '%' }),
                          onMousedown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.onHandleDrag('left', $event)), ["stop"]))
                        }, null, 36),
                        _createElementVNode("div", {
                          class: "fi-slider-handle",
                          style: _normalizeStyle({ left: _ctx.rightHandlePos + '%' }),
                          onMousedown: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.onHandleDrag('right', $event)), ["stop"]))
                        }, null, 36)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.distMin), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.distMax), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: "fi-btn-cancel",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                }, "取消"),
                _createElementVNode("button", {
                  class: "fi-btn-confirm",
                  disabled: _ctx.confirmDisabled,
                  style: _normalizeStyle(_ctx.confirmBtnStyle),
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
                }, _toDisplayString(_ctx.loadingOptions ? '加载中...' : '确定'), 13, _hoisted_39)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showDescTip)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fi-desc-tip",
            style: _normalizeStyle({ left: _ctx.descTipPos.x + 'px', top: _ctx.descTipPos.y + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionListWithDesc, (opt) => {
              return (_openBlock(), _createElementBlock("div", {
                key: opt.attrCode,
                class: "fi-desc-tip-item"
              }, [
                _createElementVNode("span", {
                  class: "fi-desc-tip-name",
                  style: _normalizeStyle({ color: _ctx.colors.textSecondary })
                }, _toDisplayString(opt.attrName) + "：", 5),
                _createElementVNode("span", _hoisted_40, _toDisplayString(opt.attrDesc), 1)
              ]))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}